export default __webpack_public_path__ + "static/media/hardarch.58bb97a9.jpg";